import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import { merge } from 'lodash';
import { enableProdMode } from '@angular/core';
import { Settings } from 'luxon';
import '@angular/common/locales/global/de';

function extendConfiguration(environment: unknown): Promise<void> {
  return new Promise((resolve, reject) => {
    const httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = () => {
      if (httpRequest.readyState === XMLHttpRequest.DONE) {
        if (httpRequest.status === 200) {
          const environmentSettings = JSON.parse(httpRequest.responseText);
          merge(environment, environmentSettings);
          resolve();
        } else {
          reject(new Error('there was a problem with loading the environment settings'));
        }
      }
    };
    httpRequest.open('GET', 'settings.json');
    httpRequest.send();
  });
}

extendConfiguration(environment).then(async () => {
  if (environment.production) {
    enableProdMode();
  }

  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.envName,
    release: environment.version,
    sendDefaultPii: true,
  });

  const { appConfig } = await import('./app/app.config');
  const { AppComponent } = await import('./app/app.component');

  Settings.defaultLocale = 'de-CH';
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
});
